import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import InsuranceContext from '../../../Insurance/contexts/InsuranceContext';
import InsuranceForm, { validateInsuranceForm } from './InsuranceFormV2';

const IAM_POLICYHOLDER = 'i_am';

const Insurance = (props) => {
  const [
    formAction,
    setFormAction,
    testGroup
  ] = [
    props.formAction,
    props.setFormAction,
    props.test_group
  ];

  useEffect(() => {
    [
      ['insurance_status', formAction.showInsuranceInformation ? 0 : 1],
      [
        'insurance_primary_member_date_of_birth(1i)',
        formAction.memberBirthYear,
      ],
      ['insurance_primary_member_date_of_birth(3i)', formAction.memberBirthDay],
      [
        'insurance_primary_member_date_of_birth(2i)',
        formAction.memberBirthMonth,
      ],
      [
        'insurance_secondary_member_date_of_birth(1i)',
        formAction.memberSecondaryBirthYear,
      ],
      [
        'insurance_secondary_member_date_of_birth(3i)',
        formAction.memberSecondaryBirthDay,
      ],
      [
        'insurance_secondary_member_date_of_birth(2i)',
        formAction.memberSecondaryBirthMonth,
      ]
    ].map((field) => {
      $(`input[name="user[${field[0]}]"][type=hidden]`).remove();
      $('<input />')
        .attr('type', 'hidden')
        .attr('name', `user[${field[0]}]`)
        .attr('value', field[1])
        .appendTo('#checkInModal, #checkInForm');
    });
  }, [formAction.memberBirthMonth,
      formAction.memberBirthYear,
      formAction.memberBirthDay,
      formAction.memberSecondaryBirthMonth,
      formAction.memberSecondaryBirthYear,
      formAction.memberSecondaryBirthDay,
      formAction.showInsuranceInformation,
    ]
  );

  const insuranceView = {
    view: (props) => <InsuranceForm {...props} />,
    validate: validateInsuranceForm,
  };

  return (
    <React.Fragment>
      <main>
        <div className="mt-4 bg-white">
          <InsuranceContext.Provider
            value={{
              testGroup,
              formAction,
              setFormAction,
              IAM_POLICYHOLDER,
            }}
          >
            <Formik
              initialValues={props}
            >
              {(formikProps) => (
                <div>
                  <div
                    className="form-inputs"
                    aria-describedby="insuranceStatusDesc"
                  >
                    {insuranceView.view(formikProps)}
                  </div>
                </div>
              )}
            </Formik>
          </InsuranceContext.Provider>
        </div>
      </main>
    </React.Fragment>
  );
};

export default Insurance;
